import { render, staticRenderFns } from "./UnifiedOffers.vue?vue&type=template&id=78465480&"
import script from "./UnifiedOffers.vue?vue&type=script&lang=js&"
export * from "./UnifiedOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports